import Sub from './component';

export default Sub;
